namespace $.$$ {

	export class $shm_hitalama_map_widget_contextmenu extends $.$shm_hitalama_map_widget_contextmenu {

		contextmenu_common() {
			if( this.map().can_change() ) return super.contextmenu_common()
			return [ this.Copy_id(), this.Fullscreen() ]
		}

		map(): $shm_hitalama_map {
			return this.Map_page().map()
		}

		Widget() {
			return this.Map_page().Widget( this.widget().link() ).Sub()
		}

		ref_str() {
			return this.widget().link().str
		}

		@ $mol_action
		fullscreen() {
			this.Map_page().contextmenu_showed( false )
			this.$.$mol_state_arg.value( 'fullscreen_widget', this.ref_str() )
		}

		to_front() {
			this.Map_page().widget_to_top( this.widget().link() )
			this.Map_page().contextmenu_showed( false )
		}

		to_back() {
			this.Map_page().widget_to_bottom( this.widget().link() )
			this.Map_page().contextmenu_showed( false )
		}

		open_props( next?: any ) {
			this.Map_page().widget_props_open( this.widget() )
		}

		open_in_editor_visible() {
			return this.widget().type().startsWith( 'code' ) ? super.open_in_editor_visible() : []
		}

		@ $mol_action
		open_in_editor() {
			const link = this.widget().link()
			this.Map_page().selected_links( [ link ] )
			this.Map_page().contextmenu_showed( false )
			this.$.$mol_state_arg.value( 'edit_mode', '' )
			this.$.$mol_state_arg.value( 'edit_widget', this.widget().link_str() )
		}

		@ $mol_action
		customizer_add() {
			this.Map_page().contextmenu_showed( false )
			this.$.$mol_state_arg.value( 'edit_mode', '' )
			this.$.$mol_state_arg.value( 'edit_widget', this.widget().link_str() )
		}

		@ $mol_action
		make_extension() {
			this.Map_page().contextmenu_showed( false )
			const profile = $shm_hitalama_profile.current()!
			profile.Extension_current(null)?.remote( this.widget() )
		}

		quick_access_has() {
			const items = $shm_hitalama_profile.current()?.bottom_quick_access_items()
			return items?.findIndex( it => it.id == this.ref_str() ) != -1
		}

		quick_access_title() {
			return this.quick_access_has() ? 'Удалить из панели быстрого доступа' : super.quick_access_title()
		}

		@ $mol_action
		quick_access_toggle() {
			this.Map_page().contextmenu_showed( false )
			const profile = $shm_hitalama_profile.current()!

			if( this.quick_access_has() ) {
				profile.bottom_quick_access_ordered_remove( this.widget().link_str() )
				profile.bottom_quick_access_item_remove( this.widget().link_str() )
			} else {
				profile.bottom_quick_access_new_add( this.widget().link_str() )
			}
		}

	}

	export class $shm_hitalama_map_widget_contextmenu_copy_id extends $.$shm_hitalama_map_widget_contextmenu_copy_id {

		click( event?: Event ) {
			super.click( event )
			this.Map_page().contextmenu_showed( false )
		}

	}

}
